import type { ComposeSnapshot } from '../../models/composeSnapshot';

export const resolveSnapshotLineageId = ({
  lineageId,
  sessionId,
}: ComposeSnapshot): string => lineageId ?? sessionId;

const carriesContent = (snapshot: ComposeSnapshot): boolean =>
  !snapshot.attachmentsTruncated;

// A newer session of the same lineage restored this one's content, so syncing both would write stale text over fresh.
export const isSupersededSnapshot = (
  snapshot: ComposeSnapshot,
  all: readonly ComposeSnapshot[],
): boolean => {
  const lineageId = resolveSnapshotLineageId(snapshot);
  return all.some(
    (other) =>
      other.sessionId !== snapshot.sessionId &&
      resolveSnapshotLineageId(other) === lineageId &&
      other.updatedAt > snapshot.updatedAt &&
      carriesContent(other),
  );
};

export const findSupersededSessionIds = (
  snapshots: readonly ComposeSnapshot[],
  liveSessionIds: Record<string, true>,
): string[] =>
  snapshots
    .filter(
      (snapshot) =>
        !liveSessionIds[snapshot.sessionId] &&
        isSupersededSnapshot(snapshot, snapshots),
    )
    .map(({ sessionId }) => sessionId);
